var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 521 241.7",
    style: {
      enableBackground: "new 0 0 521 241.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFEFEF;}\n\t.st1{fill:#FFFFFF;stroke:#AFAFAF;stroke-width:1.75;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#AFAFAF;stroke-width:1.75;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#AFAFAF;stroke-width:1.74;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#AFAFAF;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#FFFFFF;stroke:#3F3F3F;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:none;stroke:#3F3F3F;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:none;}\n\t.st9{fill:#E84D4D;}\n\t.st10{font-family:'Montserrat';}\n\t.st11{font-size:28.35px;}\n\t.st12{letter-spacing:-1;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:0.3937;stroke-miterlimit:10;}\n\t.st14{fill:#3F3F3F;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shipping-page-graphics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.9,
    y: 13,
    className: "st0",
    width: 23.8,
    height: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,222.2c0,0-3-21.2-1.3-33.3c1.5-11,11.6-19.5,16.1-21.8s15.3-3,17-2.6c3.8,0.9,5.3,0.9,0.9-1.2 c3.6-3.6,6.4-7.9,8.7-15c-3.1,6.5-6.3,10.8-9.2,13.1c-5.2,0.7-13,0.3-12.6-1.6c1.8-9.4,16.1-21.6,15.5-22.5 c-0.8-1.3-13.4,9.3-19.8,23.6c-1.5,3.2-10.6,7.1-11.2,7c0,0,0.7-20.2,1.1-21.3c2.8-7.2,14-13.7,13.8-14.5 c-0.6-0.5-16.9,9.8-17.5,15.7c-0.7,6.3-0.1,18.7-1.4,23.7s-5,11-5.7,11.2c-1.6,0.5-6-7.9-6.8-10.6c-0.4-1.2-1-22.7-0.7-24.7 c0.9-7,6.4-14.9,6.1-15.3c-0.9-1.2-8,8.2-8.1,8.5c-1.1-0.1-13.6-10.8-14.3-9.7c-0.4,0.7,9.4,10.7,11.8,17.4c0.7,1.9,1,19.7,1,19.7 c-2.2,0.2-11.1-7-11.1-7c-3.3-11.2-16-22-16.9-20.8c-0.5,0.8,12.4,10.8,12.1,19.9c-2.9,3.4-12.1,1.4-12.4,2.3 c-0.2,1,9.2,2.7,15.1,2.8s19.4,14.1,20.4,29.1c0.8,12.6-3,27.8-3,27.8h13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.8,140.1c-0.2-1-0.2-1.9-0.2-2.9c-0.1-9.4,7.4-17.2,16.8-17.3c1.7,0,3.4,0.3,5,0.8 c1.3-12.3,12.3-21.1,24.5-19.8c10.4,1.1,18.7,9.3,19.8,19.7c1.4-0.4,2.9-0.6,4.4-0.6c9.4,0.1,16.9,7.9,16.8,17.3 c0,1-0.1,2-0.2,2.9c7.4,1.1,12.6,8,11.4,15.5c-1.1,7.4-8,12.6-15.5,11.4c-6.3-0.9-11.1-6.2-11.6-12.6c-0.3,0-0.7,0-1,0 c-6.9-0.1-13-4.3-15.5-10.7c-7,4.1-15.7,4-22.6-0.3c-2.4,6.5-8.7,10.9-15.6,11c-0.3,0-0.7,0-1,0c-0.4,7.1-6.1,12.6-13.2,12.7 c-7.5-0.2-13.5-6.5-13.2-14.1C1.1,146.8,5.6,141.4,11.8,140.1L11.8,140.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,146.5c-4.7,0.1-11.6-3-11.6-3c-7.1,12-16.6,10.9-16.6,10.9c-0.9,2.9-2.1,5.7-3.6,8.4 c-5.4,8.6-15,2.4-15,2.4c14,2.8,16.9-15.9,16.9-15.9c12.8,1.2,18.3-14.2,18.3-14.2s9.6,6.4,23.5,0.7c0,0,2.4,7.5,7.3,8.1l-5.1,5.5 c-1.4-1.6-2.4-3.5-3.1-5.6C66.5,143.8,63.9,146.3,55.6,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.8,140.1c-0.2-1-0.2-1.9-0.2-2.9c-0.1-9.4,7.4-17.2,16.8-17.3c1.7,0,3.4,0.3,5,0.8 c1.3-12.3,12.3-21.1,24.5-19.8c10.4,1.1,18.7,9.3,19.8,19.7c1.4-0.4,2.9-0.6,4.4-0.6c9.4,0.1,16.9,7.9,16.8,17.3 c0,1-0.1,2-0.2,2.9c7.4,1.1,12.6,8,11.4,15.5c-1.1,7.4-8,12.6-15.5,11.4c-6.3-0.9-11.1-6.2-11.6-12.6c-0.3,0-0.7,0-1,0 c-6.9-0.1-13-4.3-15.5-10.7c-7,4.1-15.7,4-22.6-0.3c-2.4,6.5-8.7,10.9-15.6,11c-0.3,0-0.7,0-1,0c-0.4,7.1-6.1,12.6-13.2,12.7 c-7.5-0.2-13.5-6.5-13.2-14.1C1.1,146.8,5.6,141.4,11.8,140.1L11.8,140.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.3,
    y: 83.2,
    className: "st2",
    width: 64.6,
    height: 139
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 135.3,
    y1: 154.9,
    x2: 135.3,
    y2: 222.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "83.5,222.2 83.5,218.7 123.9,218.7 123.9,222  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 135.4,
    y1: 83.2,
    x2: 135.4,
    y2: 146.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 180.9,
    y1: 73.7,
    x2: 180.9,
    y2: 221.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.7,
    y: 73.6,
    className: "st0",
    width: 218.6,
    height: 6.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 398.7,
    y1: 73.7,
    x2: 398.7,
    y2: 137.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 249.9,
    y1: 154,
    x2: 249.9,
    y2: 222.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 330.1,
    y1: 154.4,
    x2: 330.1,
    y2: 222.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 496.2,
    y1: 155.3,
    x2: 496.2,
    y2: 221.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "435.7,135.7 495.6,160.6 495.6,153.9 439.6,130 382.6,154 382.6,157.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "476.4,165.8 469.9,221.8 479.2,221.8 479.2,217.8 479.2,165.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "238.5,151 243,157.8 290.2,130.4 337.1,158.2 342,150.6 290.2,119.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "170.5,73.3 409.7,73.3 385.1,31.4 195.9,31.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.2,
    y: 89.8,
    className: "st4",
    width: 37,
    height: 36.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 221.3,
    y1: 89.7,
    x2: 221.3,
    y2: 125.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 224.4,
    y1: 89.7,
    x2: 224.4,
    y2: 125.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 204.3,
    y1: 107.8,
    x2: 221,
    y2: 107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 224.4,
    y1: 107.8,
    x2: 241.1,
    y2: 107.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.8,
    y: 89.6,
    className: "st4",
    width: 18.2,
    height: 18.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "275.4,221.6 275.4,169.9 304.1,169.9 304.1,221.7  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 297.9,
    cy: 196.5,
    r: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 382.6,
    y1: 153.8,
    x2: 382.6,
    y2: 221.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "439.7,120.4 372,149.3 375.4,156.7 439.7,129.8 502.9,157.5 506.8,149.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 439.7,
    cy: 147.6,
    r: 4.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "399,221.6 399,165.8 479.6,165.8 479.6,222.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341,31.4V13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M365,31.4V13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M338,6.8v5.8h30V6.8C368,6.8,338,6.6,338,6.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 399.3,
    y1: 177.2,
    x2: 480.2,
    y2: 177.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 399.3,
    y1: 188.6,
    x2: 480.2,
    y2: 188.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 399.3,
    y1: 200,
    x2: 480.2,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 399.3,
    y1: 211.4,
    x2: 480.2,
    y2: 211.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 165.4,
    className: "st3",
    width: 25.1,
    height: 36.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 217.6,
    y1: 166,
    x2: 217.6,
    y2: 201.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.2,
    y: 165.4,
    className: "st3",
    width: 25.1,
    height: 36.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 362.8,
    y1: 166,
    x2: 362.8,
    y2: 201.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.1,
    y: 126.1,
    className: "st4",
    width: 45.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.5,
    y: 89.8,
    className: "st4",
    width: 37,
    height: 36.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 355.5,
    y1: 89.7,
    x2: 355.5,
    y2: 125.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 358.6,
    y1: 89.7,
    x2: 358.6,
    y2: 125.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 338.6,
    y1: 107.8,
    x2: 355.3,
    y2: 107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 358.7,
    y1: 107.8,
    x2: 375.4,
    y2: 107.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.3,
    y: 126.1,
    className: "st3",
    width: 45.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 129.4,
    className: "st0",
    width: 46,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.9,
    y: 129.4,
    className: "st0",
    width: 46,
    height: 3.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "287.4,136.4 329.5,161.1 329.5,154.4 290.1,130.8 249.9,154.5 249.9,158.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 70.2,
    y1: 222.2,
    x2: 70.2,
    y2: 154.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.2,
    y: 146.4,
    className: "st1",
    width: 69.1,
    height: 8.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.2,
    y: 74.9,
    className: "st3",
    width: 69.1,
    height: 8.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.1,211.5c0.6,0.2,65.3,0,65.3,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "85.7,218.7 85.7,215 121.7,215 121.7,218.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 88,
    y1: 211.7,
    x2: 88,
    y2: 215.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 119.4,
    y1: 211.7,
    x2: 119.4,
    y2: 214.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 165.2,
    className: "st3",
    width: 24.4,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 96,
    className: "st3",
    width: 35.4,
    height: 38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 70.3,
    y1: 146.4,
    x2: 70.3,
    y2: 83.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 81.4,
    y1: 134.1,
    x2: 124,
    y2: 134.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 102.7,
    y1: 96.2,
    x2: 102.7,
    y2: 134.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 85,
    y1: 115.2,
    x2: 120.5,
    y2: 115.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1,222.2c0,0-3-15.8,11.3-17.3c4.8-0.5,9.7,3,9.7,3s5.4-5.3,12.7-3.5c5.1,1.3,8.5,6,8.2,11.2 c0,0,4.5-2.5,7.8,0.8c1.9,1.9,1.1,5.7,1.1,5.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 497.5,
    y1: 238.7,
    x2: 31,
    y2: 238.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 502.2,
    y1: 238.7,
    x2: 521,
    y2: 238.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 6.9,
    y1: 238.7,
    x2: 26.4,
    y2: 238.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 25,
    y1: 222.2,
    x2: 496.2,
    y2: 222.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M147.3,211.2c0-14.9,12.1-27.1,27.1-27.1s27.1,12.1,27.1,27.1s-12.1,27.1-27.1,27.1c0,0,0,0,0,0 C159.4,238.3,147.3,226.2,147.3,211.2C147.3,211.3,147.3,211.3,147.3,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M158,211.2c0-9,7.3-16.3,16.3-16.3c9,0,16.3,7.3,16.3,16.3c0,9-7.3,16.3-16.3,16.3c0,0,0,0,0,0 C165.3,227.6,158,220.3,158,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.1,197.2h5.1c1.3,0,2.3,1.1,2.3,2.4v9.4c0,1.3-1,2.3-2.3,2.4c0,0,0,0,0,0H126.1c-1.3,0-2.3-1-2.3-2.3 c0,0,0,0,0,0v-9.4c0-1.3,1-2.3,2.3-2.4h5.1H376.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "151.3,197.2 131.1,197.2 131.1,69.4 277.2,69.4 277.2,197.2 195.6,197.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "197.4,197.2 277.2,197.2 277.2,69.4 131.1,69.4 131.1,197.2 150.2,197.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.1,197.2v-6.1c0-20.3-2.6-25-7-35.2c-10-23-26.9-60.6-49.3-60.6h-42.7v101.9H376.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.5,109.4v46.1h57.2c0,0-14.9-46.1-36-46.1L295.5,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M375.1,173.9h-18.4c-1.3,0-2.3,1-2.3,2.3c0,0,0,0,0,0v7.8c0,1.3,1,2.3,2.3,2.3c0,0,0,0,0,0h19.4 C376,182.2,375.7,178,375.1,173.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.6,186.7h163.1c0,0,7.9-9.7,23.6-9.7c12.9,0,22.9,5.2,28.1,13.3h29.7v6.9c0,0,5.6-1.9,7.4,2.4 s2.1,10.3-2.3,11.7s-31.6,0-31.6,0s0.2-27.1-27.1-27.1s-27.1,27.1-27.1,27.1H126.1c-4.4,0-2.3-6.7-2.3-11.7s7.4-2.4,7.4-2.4 L131.6,186.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M376.1,197.2h5.1c1.3,0,2.3,1.1,2.3,2.4v9.4c0,1.3-1,2.3-2.3,2.4c0,0,0,0,0,0H126.1c-1.3,0-2.3-1-2.3-2.3 c0,0,0,0,0,0v-9.4c0-1.3,1-2.3,2.3-2.4h5.1H376.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "151.3,197.2 131.1,197.2 131.1,69.4 277.2,69.4 277.2,197.2 195.6,197.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "197.4,197.2 277.2,197.2 277.2,69.4 131.1,69.4 131.1,197.2 150.2,197.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M376.1,197.2v-6.1c0-20.3-2.6-25-7-35.2c-10-23-26.9-60.6-49.3-60.6h-42.7v101.9H376.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M295.5,109.4v46.1h57.2c0,0-14.9-46.1-36-46.1L295.5,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M375.1,173.9h-18.4c-1.3,0-2.3,1-2.3,2.3c0,0,0,0,0,0v7.8c0,1.3,1,2.3,2.3,2.3c0,0,0,0,0,0h19.4 C376,182.2,375.7,178,375.1,173.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.6,
    y: 100.4,
    className: "st9",
    width: 61.8,
    height: 61.8
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 179.1386 138.8465)",
    className: "st2 st10 st11 st12"
  }, "bcp"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 179.1386 138.8465)",
    className: "st13 st10 st11 st12"
  }, "bcp"), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.5,211.2c0-14.9,12.1-27.1,27.1-27.1s27.1,12.1,27.1,27.1c0,14.9-12.1,27.1-27.1,27.1c0,0,0,0,0,0 C307.6,238.3,295.5,226.2,295.5,211.2C295.5,211.3,295.5,211.3,295.5,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M306.3,211.2c0-9,7.3-16.3,16.3-16.3c9,0,16.3,7.3,16.3,16.3c0,9-7.3,16.3-16.3,16.3c0,0,0,0,0,0 C313.6,227.6,306.3,220.3,306.3,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M277.2,69.4v25.8h42.7c22.4,0,39.3,37.6,49.3,60.6c4.4,10.2,7,14.9,7,35.2v6.1h5.1c1.3,0,2.3,1.1,2.3,2.4 v9.4c0,1.3-1,2.3-2.3,2.4c0,0,0,0,0,0h-31.6v0c0,14.9-12.1,27.1-27.1,27.1s-27.1-12.1-27.1-27.1v0h-94.1v0 c0,14.9-12.1,27.1-27.1,27.1c-14.9,0-27-12.1-27.1-27.1v0h-21.2c-1.3,0-2.3-1-2.3-2.3c0,0,0,0,0,0v-9.4c0-1.3,1-2.3,2.3-2.4h5.1 V69.4H277.2 M277.2,66.4h-146c-1.7,0-3,1.3-3,3v124.7h-2.1c-3,0-5.3,2.4-5.3,5.4v9.4c0,3,2.4,5.3,5.3,5.4h18.4 c1.7,16.5,16.4,28.6,32.9,26.9c14.2-1.4,25.5-12.7,26.9-26.9h88.4c1.7,16.5,16.4,28.6,32.9,26.9c14.2-1.4,25.5-12.7,26.9-26.9 h28.7c3,0,5.3-2.4,5.3-5.4v-9.4c0-3-2.4-5.3-5.3-5.4h-2.1c0-0.8,0-1.8,0-3.1c0-19.8-2.5-25.4-6.5-34.6c-0.2-0.6-0.5-1.2-0.8-1.8 c-9.5-21.8-27.1-62.4-52.1-62.4h-39.7V69.4C280.2,67.8,278.8,66.4,277.2,66.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.1db8cff4e4e9d5e3e25f56f6531dbf9a.svg";
export { ForwardRef as ReactComponent };